import styled, { css } from "styled-components"

export const ItemsEditorWrapper = styled.div`
  height: 100%;
  padding: 52px;
  background: #f6fafe;
  
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 38px;

  p {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .quill {
    background-color: #ffffff;
    border: 1px solid #ebebeb;
    border-radius: 3px;
  }

  .ql-toolbar.ql-snow {
    border-width: 0 0 1px 0;
    border-color: #ebebeb;
  }

  .ql-container.ql-snow {
    border: 0;
    overflow: hidden;
  }

  .ql-editor b,
  .ql-editor strong {
    font-weight: 600 !important;
  }

  .ql-editor em {
    font-style: italic;
  }

  .ql-editor {
    border-radius: 0px 0px 3px 3px;
    border: 1px solid transparent;

    :focus {
      border-color: rgb(80, 175, 244);
    }
  }

  .ql-toolbar.ql-snow .ql-formats {
    position: relative;
    margin-right: 5px;

    &:not(:last-child):after {
      content: '';
      display: block;
      position: absolute;
      height: 100%;
      width: 1px;
      background-color: #ebebeb;
      right: -3px;
    }
  }

  .ql-snow.ql-toolbar button {
    border-radius: 3px;
    color: #313131;

    &:hover {
      color: #313131;
      background-color: #F6FAFE;

      .ql-stroke {
        stroke: #313131;
      }

      .ql-fill {
        fill: #313131;
      }
    }

    &.ql-active {
      stroke: #50AFF4;
      fill: #50AFF4;

      &:hover {
        color: #50AFF4;
        background-color: #F6FAFE;
      }
      
      .ql-stroke {
        stroke: #50AFF4;
      }
  
      .ql-fill {
        fill: #50AFF4;
      }
    }
  }

  .ql-tooltip {
    left: 0 !important;
  }

  .ql-snow .ql-tooltip[data-mode=link]::before {
    content: "Link"
  }

  ${({ locale }) => {
    const translationsInsertLink = {
      "pt-BR": "Salvar",
      "pt-PT": "Salvar",
      "en": "Save",
      "es": "Guardar"
    }
    
    const translationsEditLink = {
      "pt-BR": {
        "visit": "Visitar URL",
        "edit": "Editar",
        "remove": "Remover"
      },
      "pt-PT": {
        "visit": "Visitar URL",
        "edit": "Editar",
        "remove": "Remover"
      },
      "en": {
        "visit": "Visit URL",
        "edit": "Edit",
        "remove": "Remove"
      },
      "es": {
        "visit": "Visitar URL",
        "edit": "Editar",
        "remove": "Eliminar"
      }
    }
    
    return css`
      .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        content: "${translationsInsertLink[locale]}"
      }
      
      .ql-snow .ql-tooltip::before {
        content: "${translationsEditLink[locale].visit}"
      }

      .ql-snow .ql-tooltip a.ql-action::after {
        content: "${translationsEditLink[locale].edit}"
      }

      .ql-snow .ql-tooltip a.ql-remove::before {
        content: "${translationsEditLink[locale].remove}"
      }
    `
  }}
`

export const EditorTitle = styled.h2`
  font-size: 17px;
  font-weight: 500;
`

export const EditorQuestionWrapper = styled.div` 
  .ql-editor {
    height: 84px;
  }
`

export const EditorAnswerWrapper = styled.div` 
  .ql-editor {
    height: 220px;
  }
  
  .wordsCounter {
    font-size: 11px;
    margin-top: 6px;
    color: #767676;
    display: flex;
    gap: 14px;
    justify-content: flex-end;
  }
`